// extracted by mini-css-extract-plugin
module.exports = {"component":"content-search-banner_component___KW8A","text":"content-search-banner_text__Vy_Zw"};